// import "./App.css";
// import Dashboard from "./Dashboard";
// import AdminUsers from "./AdminUsers";
// import { BrowserRouter as Router, Route, Routes, Link } from "react-router-dom";
// import AuthPage from "./Authpage";
// import Middleware from "./middleware";
// import Organizations from "./Organizations";

// function App() {
//   const logout = () => {
//     localStorage.removeItem("token");
//     window.location.href = "/";
//   };

//   const isLoggedIn = !!localStorage.getItem("token");

//   return (
//     <Router>
//       <div className="min-h-screen bg-gray-100">
//         <nav className="bg-white shadow-lg">
//           <div className="max-w-7xl mx-auto px-4">
//             <div className="flex justify-between items-center h-16">
//               <div className="flex items-center space-x-4">
//                 <Link
//                   to="/"
//                   className="text-2xl font-bold text-indigo-600 hover:text-indigo-700 transition-colors"
//                 >
//                   Admin Panel
//                 </Link>
//               </div>

//               <div className="flex items-center space-x-4">
//                 {isLoggedIn ? (
//                   <>
//                     <Link
//                       to="/"
//                       className="text-gray-600 hover:text-indigo-600 px-3 py-2 rounded-md text-sm font-medium transition-colors"
//                     >
//                       Plans
//                     </Link>

//                     <Link
//                       to="/admins"
//                       className="text-gray-600 hover:text-indigo-600 px-3 py-2 rounded-md text-sm font-medium transition-colors"
//                     >
//                       Admin Users
//                     </Link>

//                     <Link
//                       to="/organizations"
//                       className="text-gray-600 hover:text-indigo-600 px-3 py-2 rounded-md text-sm font-medium transition-colors"
//                     >
//                       Organizations
//                     </Link>

//                     <button
//                       onClick={logout}
//                       className="text-gray-600 cursor-pointer hover:text-indigo-600 px-3 py-2 rounded-md text-sm font-medium transition-colors"
//                     >
//                       Logout
//                     </button>
//                   </>
//                 ) : (
//                   <Link
//                     to="/auth/true"
//                     className="text-gray-600 hover:text-indigo-600 px-3 py-2 rounded-md text-sm font-medium transition-colors"
//                   >
//                     Login
//                   </Link>
//                 )}
//               </div>
//             </div>
//           </div>
//         </nav>

//         <div className="max-w-7xl mx-auto px-4 py-6">
//           <Routes>
//             <Route element={<Middleware />}>
//               <Route path="/" element={<Dashboard />} />
//               <Route path="/admins" element={<AdminUsers />} />
//               <Route path="/organizations" element={<Organizations />} />
//             </Route>
//             <Route path="/auth/:login" element={<AuthPage />} />
//           </Routes>
//         </div>
//       </div>
//     </Router>
//   );
// }

// export default App;

import "./App.css";
import Dashboard from "./Dashboard";
import AdminUsers from "./AdminUsers";
import Organizations from "./Organizations";
import AuthPage from "./Authpage";
import Middleware from "./middleware";
import { BrowserRouter as Router, Route, Routes, Link, useLocation } from "react-router-dom";
import { FiShield, FiGrid, FiUsers, FiLayers, FiLogOut, FiLock } from "react-icons/fi";

function AdminShell() {
  const location = useLocation();
  const isLoggedIn = !!localStorage.getItem("token");
  const isAuthPage = location.pathname.startsWith("/auth/");

  const logout = () => {
    localStorage.removeItem("token");
    window.location.href = "/auth/true";
  };

  const navItems = [
    { to: "/", label: "Plans", icon: FiGrid },
    { to: "/admins", label: "Admin Users", icon: FiUsers },
    { to: "/organizations", label: "Organizations", icon: FiLayers },
  ];

  const isActive = (path) => {
    if (path === "/") return location.pathname === "/";
    return location.pathname.startsWith(path);
  };

  return (
    <div className="min-h-screen bg-slate-950 text-slate-100">
      {!isAuthPage ? (
        <div className="relative min-h-screen overflow-hidden">
          <div className="absolute inset-0 bg-[radial-gradient(circle_at_top_left,_rgba(168,85,247,0.18),_transparent_30%),radial-gradient(circle_at_bottom_right,_rgba(59,130,246,0.16),_transparent_28%),linear-gradient(180deg,#020617_0%,#0f172a_48%,#111827_100%)]" />
          <div className="absolute inset-0 opacity-[0.06] [background-image:linear-gradient(rgba(255,255,255,0.28)_1px,transparent_1px),linear-gradient(90deg,rgba(255,255,255,0.28)_1px,transparent_1px)] [background-size:48px_48px]" />

          <div className="relative z-10">
            <header className="sticky top-0 z-30 border-b border-white/10 bg-slate-950/70 backdrop-blur-xl">
              <div className="mx-auto flex max-w-7xl items-center justify-between px-4 py-4 sm:px-6 lg:px-8">
                <div className="flex items-center gap-4">
                  <Link to="/" className="flex items-center gap-3">
                    <div className="flex h-11 w-11 items-center justify-center rounded-2xl border border-white/15 bg-white/10 shadow-lg shadow-purple-900/20">
                      <FiShield className="text-xl text-violet-300" />
                    </div>

                    <div>
                      <div className="text-xl font-bold tracking-tight text-white">
                        E-Lex Signature
                      </div>
                      <div className="text-sm text-slate-300">Platform Admin</div>
                    </div>
                  </Link>

                  {isLoggedIn ? (
                    <div className="hidden xl:flex">
                      <span className="rounded-full border border-emerald-400/20 bg-emerald-400/10 px-3 py-1.5 text-xs font-medium text-emerald-200">
                        Restricted access • Super Admin only
                      </span>
                    </div>
                  ) : null}
                </div>

                <div className="flex items-center gap-3">
                  {isLoggedIn ? (
                    <>
                      <nav className="hidden items-center gap-2 lg:flex">
                        {navItems.map((item) => {
                          const Icon = item.icon;
                          const active = isActive(item.to);

                          return (
                            <Link
                              key={item.to}
                              to={item.to}
                              className={`inline-flex items-center gap-2 rounded-2xl px-4 py-2 text-sm font-medium transition ${
                                active
                                  ? "border border-violet-400/25 bg-violet-500/15 text-white shadow-sm"
                                  : "border border-transparent bg-white/5 text-slate-300 hover:border-white/10 hover:bg-white/10 hover:text-white"
                              }`}
                            >
                              <Icon className="text-base" />
                              {item.label}
                            </Link>
                          );
                        })}
                      </nav>

                      <button
                        onClick={logout}
                        className="inline-flex items-center gap-2 rounded-2xl border border-white/10 bg-white/5 px-4 py-2 text-sm font-medium text-slate-200 transition hover:border-red-400/30 hover:bg-red-500/10 hover:text-white"
                      >
                        <FiLogOut className="text-base" />
                        Logout
                      </button>
                    </>
                  ) : (
                    <Link
                      to="/auth/true"
                      className="inline-flex items-center gap-2 rounded-2xl border border-white/10 bg-white/5 px-4 py-2 text-sm font-medium text-slate-200 transition hover:border-violet-400/30 hover:bg-violet-500/10 hover:text-white"
                    >
                      <FiLock className="text-base" />
                      Login
                    </Link>
                  )}
                </div>
              </div>

              {isLoggedIn ? (
                <div className="border-t border-white/5 lg:hidden">
                  <div className="mx-auto flex max-w-7xl gap-2 overflow-x-auto px-4 py-3 sm:px-6 lg:px-8">
                    {navItems.map((item) => {
                      const Icon = item.icon;
                      const active = isActive(item.to);

                      return (
                        <Link
                          key={item.to}
                          to={item.to}
                          className={`inline-flex shrink-0 items-center gap-2 rounded-2xl px-4 py-2 text-sm font-medium transition ${
                            active
                              ? "border border-violet-400/25 bg-violet-500/15 text-white"
                              : "border border-white/10 bg-white/5 text-slate-300"
                          }`}
                        >
                          <Icon className="text-base" />
                          {item.label}
                        </Link>
                      );
                    })}
                  </div>
                </div>
              ) : null}
            </header>

            <main className="mx-auto max-w-7xl px-4 py-6 sm:px-6 lg:px-8 lg:py-8">
              <Routes>
                <Route element={<Middleware />}>
                  <Route path="/" element={<Dashboard />} />
                  <Route path="/admins" element={<AdminUsers />} />
                  <Route path="/organizations" element={<Organizations />} />
                </Route>

                <Route path="/auth/:login" element={<AuthPage />} />
              </Routes>
            </main>
          </div>
        </div>
      ) : (
        <Routes>
          <Route path="/auth/:login" element={<AuthPage />} />
        </Routes>
      )}
    </div>
  );
}

function App() {
  return (
    <Router>
      <AdminShell />
    </Router>
  );
}

export default App;